module.exports = __webpack_public_path__ + "static/media/generated_press.afa8a1d6.txt";